import { Maatregel, Vsm } from "@/entities/vsm";
import { ReactNode, useMemo } from "react";
import { VsmActieDialogContext, VsmActieDialogContextType } from "./vsm-actie-dialog-context.tsx";

type VsmActieDialogProviderProps = {
    children: ReactNode;
    currentVsm: Vsm | undefined | null;
};

export function VsmActieDialogProvider({ children, currentVsm }: Readonly<VsmActieDialogProviderProps>) {
    const oudeToelichting = currentVsm?.toelichting ?? "";
    const oudeStatus = currentVsm?.vsmStatus ?? "Definitief";

    // Ungrouped: OudeVsm builds the RijdtGroep itself, because the grouping depends on de nieuwe versie.
    const oudeMaatregelen = useMemo((): Maatregel[] => currentVsm?.maatregelen ?? [], [currentVsm]);

    const contextValue = useMemo(
        (): VsmActieDialogContextType => ({
            oudeToelichting,
            oudeStatus,
            oudeMaatregelen,
        }),
        [oudeToelichting, oudeMaatregelen, oudeStatus]
    );
    return <VsmActieDialogContext value={contextValue}>{children}</VsmActieDialogContext>;
}
